import css from './DetallesContrato.module.css'

const DetallesContrato = () => (
  <div className={css.documento}>
    <div className={css.content}>
      <h3>Matrícula:</h3>
      <ul>
        <li>El pago de la matrícula, obligatorio y no reembolsable, asciende a 49€ y debe realizarse el primer día de clases.</li>
        <li>La matrícula caducará a los 2 meses desde la última clase recibida. No se devolverá su importe bajo ningún concepto.</li>
        <li>No se tendrá en cuenta para la caducidad de la matrícula los meses de julio y agosto.</li>
      </ul>

      <h3>Horario:</h3>
      <ul>
        <li>La flexibilidad horaria permite a los alumnos acordar el horario de clases con el centro.</li>
        <li>
          Para algunas modalidades de contratación, existen limitaciones específicas de horario:
          <ul>
            <li>La <em>Tarifa Prepara Mañanas</em> solo permite clases en horario de mañanas.</li>
            <li>La <em>Tarifa Prepara Tardes</em> solo permite clases en horario de tardes.</li>
          </ul>
        </li>
        <li>Consulta nuestra política de aperturas y posibles cambios de horario en festivos locales o nacionales (revisar política de cambios)</li>
        <li><strong>Nota importante:</strong> Las clases online mediante la plataforma de Classfy se rigen por el calendario de la ciudad de Madrid, España.</li>
      </ul>

      <h3>En el aula:</h3>
      <ul>
        <li>Se requiere que el alumno se presente con folios en blanco y bolígrafo para las clases. En el caso de asignaturas de ciencias se solicita también calculadora.</li>
        <li>El alumno debe seguir las indicaciones del docente y mantener un comportamiento respetuoso en todo momento. Conductas disruptivas pueden llevar a medidas disciplinarias, incluida la suspensión del servicio.</li>
      </ul>

      <h3>Política de Pagos y Devoluciones:</h3>
      <ul>
        <li>Todos los servicios deben ser abonados por adelantado. El centro se reserva el derecho de no permitir el acceso a clases si los servicios contratados no han sido abonados.</li>
        <li>Si el servicio contratado es una Tarifa (excepto la <em>Tarifa Base</em>), la fecha para realizar el pago mensual es hasta el día 5 del mes que se ofrece el servicio.
          <ul>
            <li>Las tarifas (excepto la <em>Tarifa Base</em>) se renuevan automáticamente de forma mensual. Para darse de baja se deberá notificar dicha baja con 5 días de antelación al inicio del mes; de lo contrario, se abonará el mes completo.</li>
          </ul>
        </li>
        <li>Si el servicio contratado es un <em>Pack de horas</em> que se oferta a lo largo del año, el pago se realizará el primer día de asistencia a clase. Consultar en secretaría los diferentes periodos de caducidad en función del número de horas</li>
        <li>Los importes realizados a cuenta no son reembolsables. Se otorgará un bono por horas pagadas, válido en el siguiente mes, solo para el cliente original.</li>
        <li>Las clases presenciales canceladas se podrán ofrecer en modalidad online, sin derecho a reembolso, tras coordinación con el alumno.</li>
      </ul>

      <h3>Política de cambios y devoluciones:</h3>
      <p>En caso de cambios o ausencias, el alumno debe notificar al centro con al menos 1 día laborable de antelación.</p>
      <p>En caso de avisar en el plazo establecido:</p>
      <ul>
        <li>
          <strong>Tarifa Refuerza:</strong>
          <ul>
            <li>El alumno tendrá derecho a cambiar horas abonando 2,5€ por hora, sujeto a disponibilidad en el aula (incluido festivos).</li>
            <li>Si no hay disponibilidad en el aula habitual, las clases podrán recuperarse en otro centro, coordinando previamente.</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>Tarifa Base / Pack horas:</strong>
          <ul>
            <li>Podrá mover horas a otra fecha y horario, sujeto a disponibilidad de aula.</li>
            <li>Si no hay disponibilidad en el aula habitual, las clases podrán recuperarse en otro centro, coordinando previamente.</li>
          </ul>
        </li>
      </ul>
      <p>Fuera del plazo establecido o sin previo aviso:</p>
      <ul>
        <li>
          <strong>Tarifa refuerza:</strong>
          <ul>
            <li>El alumno perderá las horas sin posibilidad de recuperación.</li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <strong>Tarifa Base / Pack horas:</strong>
          <ul>
            <li>El alumno perderá las horas contratadas sin posibilidad de cambios ni reembolsos.</li>
          </ul>
        </li>
      </ul>
      <p>En caso de coincidir las clases con días festivos, las horas de clase no podrán ser recuperadas siguiendo la política de cambios anteriormente enunciada. La recuperación será de carácter opcional, solo si el cliente lo desea.</p>
      <p>Este hecho busca que el cliente no pierda un dia de clase y, a su vez, pueda recuperar  cada hora a 2,5€. Este hecho aplicará únicamente en <em>Tarifa Refuerza</em>.</p>

      <h3>Periodo de desistimiento:</h3>
      <ul>
        <p>El cliente dispone de 14 días naturales para ejercer el derecho de desistimiento.</p>
        <li>En caso de desistimiento, las clases ya disfrutadas se facturarán a 20€ por hora, según los servicios prestados.</li>
        <li>La matrícula, siendo un cargo no reembolsable, no está sujeta a devolución en ninguna circunstancia.</li>
      </ul>
      <hr />
      <p>Las clases impartidas no conducen a la obtención de un título con valor oficial.</p>
      <p>Mediante el pago de la matrícula o bono, el cliente manifiesta entender y aceptar estas condiciones.</p>
    </div>
  </div>
)

export default DetallesContrato